import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n/index.js';

import 'vant/lib/index.css';
import './styles/index.less';

import customToast from '@/components/MyToast/index.js';
import customLoading from '@/components/MyLoading/index.js';

Vue.prototype.$showToast = customToast.showToast;
Vue.prototype.$showLoading = customLoading.showLoading;
Vue.prototype.$hideLoading = customLoading.hideLoading;
Vue.prototype.$locale = i18n.locale;

import './directives/index';

Vue.config.productionTip = false;

import { Form, Field, Cell, Picker, Popup, Calendar, Uploader, Button } from 'vant';

Vue.use(Form).use(Field).use(Cell).use(Picker).use(Popup).use(Calendar).use(Uploader).use(Button);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
